import { Box, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

export function formatRoasVectorTooltipLabel(vectorPct, spend) {
  if (!vectorPct?.length || !(Number(spend) > 0)) {
    return '';
  }
  const header = `Hill ROAS at $${Math.round(spend).toLocaleString()} spend`;
  const lines = vectorPct.map(
    (value, index) => `M${index}: ${Number(value).toFixed(1)}%`
  );
  return [header, ...lines].join('\n');
}

function MarketingRoasVectorTooltip({ vectorPct, spend, children }) {
  const label = formatRoasVectorTooltipLabel(vectorPct, spend);
  return (
    <Tooltip
      label={
        label ? (
          <Box whiteSpace="pre" fontFamily="mono" fontSize="xs">
            {label}
          </Box>
        ) : (
          ''
        )
      }
      placement="top"
      hasArrow
      openDelay={200}
      isDisabled={!label}
    >
      <Box w="100%">{children}</Box>
    </Tooltip>
  );
}

MarketingRoasVectorTooltip.propTypes = {
  vectorPct: PropTypes.arrayOf(PropTypes.number),
  spend: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default MarketingRoasVectorTooltip;
